import { ThemeProvider, createTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import {
  useSearchParams,
} from "react-router-dom";
import { App } from '@capacitor/app';
import { useCast } from './../../cast/CastProvider';
import { getUrlForRelative } from '../../services/url';
import { v4 as uuidv4 } from 'uuid';
import Messenger from '../items/Messenger';
import CurrentTime from '../player/CurrentTime';
import { throttle } from '../../services/throttle';
import dayjs from 'dayjs';
import TR from './../../Trans';
import ForceChangePassword from '../dialogs/ForceChangePassword';
import PopUpDialog from '../dialogs/PopUpDialog';
import { Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { Chromecast } from '@gameleap/capacitor-chromecast';
import { checkIfMobile } from '../../services/screen';
import { useMediaQuery } from 'react-responsive';
import { SafeArea } from 'capacitor-plugin-safe-area';
import ExternalViewCommands from './../../services/external';
import NewAccountDialog from '../dialogs/NewAccountDialog';
import ForceAcceptTerms from '../dialogs/ForceAcceptTerms';
import IosExternalLinkDialog from '../dialogs/IosExternalLinkDialog';
import MediaQuery from 'react-responsive';
import Landscape from './Landscape';
import { getOS, getPlatform, isDesktop, isPhone, isTablet, isSamsungBrowser } from './../../services/os';
import { setSafeAreas } from './../../services/safeareas';
import Error from './../items/Error';
import Message from './../items/Message';
import Portrait from './Portrait';
import AndroidSubDialog from '../dialogs/AndroidSubDialog';
import ExternalScreen from 'cordova-plugin-wkwebview-external-screen';
import { Capacitor } from '@capacitor/core';
import StrService from './../../services/str';
import { generateId } from './../../services/random';
import MuvikaService from './../../services/muvika';
import IntervalService from './../../services/intervals';
import navigationStore from '../../stores/navigation';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import accountStore from '../../stores/account';
import messageStore from '../../stores/message';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import EditPerformance from '../dialogs/EditPerformance';
import newTracksStore from './../../stores/newTracks';
import favoritesStore from '../../stores/favorites';
import catalogStore from '../../stores/catalog';
import environmentStore from '../../stores/environment';
import musicStore from '../../stores/music';
import musicPlayerStore from '../../stores/musicPlayer';
import newsStore from '../../stores/news';
import playerStore from '../../stores/player';
import searchStore from '../../stores/search';
import songListStore from '../../stores/songList';
import singerStore from './../../stores/singers';
import timeoutsStore from '../../stores/timeouts';
import statusStore from './../../stores/status';
import homeStore from '../../stores/home';
import SubscribeDialog from '../dialogs/SubscriptionDialog';
import UpdateDialog from './../dialogs/UpdateDialog';
import MessageDialog from './../dialogs/MessageDialog';
import { AndroidExternalScreen } from 'muvika-android-external-screen';
import muvikaAttrs from './../../attrs';
import bgFiltersStore from '../../stores/bgFilters';
import bgStylesStore from '../../stores/bgStyles';
import bgPerformanceStore from '../../stores/bgPerformance';
import bgSearchStore from '../../stores/bgSearch';
import bgPlaylistsStore from './../../stores/bgPlaylists';
import { PropaneSharp } from '@mui/icons-material';
import HiddenEvents from '../items/HiddenEvents';
import { Views } from './../../enums/enums';
import songbookQueueStore from './../../stores/songbookQueue';

const songbookInterval = 10000;
const newTracksInterval = 60 * 60 * 1000;

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function resetStores(isWaitingLoggedIn = false) {
  console.log("isWaitingLoggedIn: false");
  accountStore.getState().reset();
  catalogStore.getState().reset();
  environmentStore.getState().reset();
  favoritesStore.getState().reset();
  messageStore.getState().reset();
  musicPlayerStore.getState().reset();
  musicStore.getState().reset();
  navigationStore.getState().reset();
  newsStore.getState().reset();
  homeStore.getState().reset();
  newTracksStore.getState().reset();
  performanceStore.getState().reset();
  playerStore.getState().reset();
  searchStore.getState().reset();
  sessionStore.setState({
    isSessionOpening: false,
    isThrownOut: false,
    isLoggedIn: false,
    isAckSmartQ: false,
    externalWindowHandler: null,
    isLoginSeqErrors: false,
    isLoginSeqError: false,
    isWaiting: false,
    requestCount: 0,
    isWaitingLoggedIn: isWaitingLoggedIn,
    isAndroidSubMode: false
  });
  settingsStore.getState().reset();
  singersStore.getState().reset();
  songListStore.getState().reset();
  timeoutsStore.getState().reset();
  IntervalService.clearAllIntervals();
  IntervalService.clearSongbookInterval();
  IntervalService.clearNewTracksInterval();
  IntervalService.clearAllStreamUrlTimeouts();
  IntervalService.clearSubInterval();
  bgFiltersStore.getState().reset();
  bgStylesStore.getState().reset();
  bgPerformanceStore.getState().reset();
  bgSearchStore.getState().reset();
  bgPlaylistsStore.getState().reset();
  musicPlayerStore.getState().reset();
  
}

const forceRefreshTime = 5000;

function MuvikaUI(props) {

  const [queryParameters] = useSearchParams();

  const itemsOnPage = 25;
  const session = sessionStore((state) => state.session);
  const isWaitingLoggedIn = sessionStore((state) => state.isWaitingLoggedIn);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const isSessionOpen = sessionStore((state) => state.isSessionOpen);
  const isLoggedIn = sessionStore((state) => state.isLoggedIn);
  const account = accountStore((state) => state.account);
  const getAccount = accountStore((state) => state.getAccount);
  const setError = messageStore((state) => state.setError);
  const isForceUpdate = statusStore((state) => state.isForceUpdate);
  const messageTitle = statusStore((state) => state.messageTitle);
  const message = statusStore((state) => state.message);
  const clearMessage = statusStore((state) => state.clearMessage);
  const clearUpdate = statusStore((state) => state.clearUpdate);
  const setUnsubscriptionDialogShown = navigationStore((state) => state.setUnsubscriptionDialogShown);
  const setPopUpDialogShown = navigationStore((state) => state.setPopUpDialogShown);
  const openSessionAndOneTimeLogin = sessionStore((state) => state.openSessionAndOneTimeLogin);
  const logout = sessionStore((state) => state.logout);
  const setAccount = accountStore((state) => state.setAccount);
  const settingsAccountPin = settingsStore((state) => state.settings?.account_pin);
  const currentError = messageStore((state) => state.currentError);
  const isUnsubscriptionDialogShown = navigationStore((state) => state.isUnsubscriptionDialogShown);
  const isPopUpDialogShown = navigationStore((state) => state.isPopUpDialogShown);
  const logoutChange = sessionStore((state) => state.logoutChange);
  const isMessage = statusStore((state) => state.isMessage);
  const goToView = navigationStore((state) => state.goToView);

  const handleAndroidSubDialogOk = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
      ExternalViewCommands.loadBasicToAndroidExternalScreen();
    } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      ExternalViewCommands.loadBasicToIosExternalScreen();
    }
    logoutChange(account.username, androidSubOneTimeLoginCode);
    setAndroidSubOneTimeLoginCode(null);
    setIsAndroidSubDialogOpen(false);
  };

  const [isForceAcceptTermsDialogOpen, setIsForceAcceptTermsDialogOpen] = useState(false);

  const logoutNow = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
      ExternalViewCommands.loadBasicToAndroidExternalScreen();
    } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      ExternalViewCommands.loadBasicToIosExternalScreen();
    }
    logout();
  };

  const handleCloseForceAcceptTermsDialog = () => {
    setIsForceAcceptTermsDialogOpen(false);
    resetStores();
    logoutNow();
  };

  const [isForceChangePasswordDialogOpen, setIsForceChangePasswordDialogOpen] = useState(false);

  const handleCloseForceChangePasswordDialog = () => {
    setIsForceChangePasswordDialogOpen(false);
    resetStores();
    logoutNow();
  };

  const [isAndroidSubDialogOpen, setIsAndroidSubDialogOpen] = useState(false);
  const [androidSubOneTimeLoginCode, setAndroidSubOneTimeLoginCode] = useState(null);

  const handleOpenAndroidSubDialog = () => {


    MuvikaService.createAccountLink(sessionToken, account.username, "one_time_login")
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
        } else {
          setAndroidSubOneTimeLoginCode(res.data.data.code);
          setIsAndroidSubDialogOpen(true);
        }
      })
      .catch(function () { });
  };

  const handleCloseAndroidSubDialog = () => {


    setIsAndroidSubDialogOpen(false);
  };

  const [isIosExternalLinkDialogOpen, setIsIosExternalLinkDialogOpen] = useState(false);

  const handleOpenIosExternalLinkDialog = () => {


    setIsIosExternalLinkDialogOpen(true);
  };

  const handleCloseIosExternalLinkDialog = () => {


    setIsIosExternalLinkDialogOpen(false);
  };

  const [isNewAccountDialogOpen, setIsNewAccountDialogOpen] = useState(false);

  const handleOpenNewAccountDialog = () => {


    setIsNewAccountDialogOpen(true);
  };

  const handleCloseNewAccountDialog = () => {


    setIsNewAccountDialogOpen(false);
  };

  const [isSubscribeDialogOpen, setIsSubscribeDialogOpen] = useState(false);

  const handleOpenSubscribeDialog = () => {
    setIsSubscribeDialogOpen(true);
  };

  const [isPopUpDialogOpen, setIsPopUpDialogOpen] = useState(false);

  const handleOpenPopUpDialog = () => {
    setIsSubscribeDialogOpen(true);
  };

  const handleClosePopUpDialog = () => {
    setIsPopUpDialogOpen(false);
    setPopUpDialogShown(true);
    goToView(Views.Account);
  };

  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);

  const handleOpenUpdateDialog = () => {


    setIsUpdateDialogOpen(true);
  };

  const handleCloseUpdateDialog = () => {


    setIsUpdateDialogOpen(false);
    clearUpdate();
  };

  const [isMessageDialogOpen, setIsMessageDialogOpen] = useState(false);

  const handleOpenMessageDialog = () => {


    setIsMessageDialogOpen(true);
  };

  const handleCloseMessageDialog = () => {


    setIsMessageDialogOpen(false);
    clearMessage();
  };

  const handleCloseSubscribeDialog = () => {


    setUnsubscriptionDialogShown(true);
    setIsSubscribeDialogOpen(false);
  };

  const goToShop = (sessionToken, accountId, email, url) => {


    MuvikaService.createAccountLink(sessionToken, email, "one_time_login")
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
        } else {
          window.open(url + "?origin=muvikaweb&id=" + accountId + "&login_code=" + res.data.data.code, "_self");
        }
      })
      .catch(function () { });
  };

  const handleSubscription = () => {


    if (account && session) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
        handleOpenAndroidSubDialog();
      } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        handleOpenIosExternalLinkDialog();
      } else {
        goToShop(sessionToken,
          account.account_id,
          account.username,
          session.urls.url_subscribe
        );
      }
    }
    setUnsubscriptionDialogShown(true);
  };

  const renderPopUpDialog = () => {
    return <PopUpDialog
      open={isPopUpDialogOpen}
      popupMsg={account ? account.subscription.order_info.popup_msg : null}
      onClose={handleClosePopUpDialog}
    />;
  };

  const renderSubscribeDialog = () => {
    return <SubscribeDialog
      open={isSubscribeDialogOpen}
      failureMsg={account ? account.subscription.order_info.failure_msg : null}
      onClose={handleCloseSubscribeDialog}
      onSubscription={handleSubscription}
    />;
  };

  const handleRefresh = () => {


    window.location.reload();
  };

  const renderUpdateDialog = () => {


    return <UpdateDialog
      open={isUpdateDialogOpen}
      isForceUpdate={isForceUpdate}
      onClose={handleCloseUpdateDialog}
      onOkay={handleRefresh}
    />;
  };

  useEffect(() => {
    setIsMessageDialogOpen(isMessage);
  }, [isMessage]);

  const renderMessageDialog = () => {


    return <MessageDialog
      open={isMessageDialogOpen}
      title={messageTitle}
      message={message}
      onClose={handleCloseMessageDialog}
    />;
  };

  const renderView = () => {
    let isMobile = checkIfMobile();
    if (isMobile) {
      return <Portrait />;
    } else {
      return <Landscape />;
    }
  };

  const handleChangePassword = (oldPassword, newPassword1, newPassword2) => {
    if (oldPassword.length == 0 ||
      newPassword1.length == 0 ||
      newPassword2.length == 0) {
      setError(sessionToken, 0, TR.cm_fill_all_fields);
      return;
    }
    if (newPassword1.length >= 8) {
      if (newPassword1 === newPassword2) {
        MuvikaService.changePassword(sessionToken, account.username, oldPassword, newPassword1)
          .then(function (res) {
            if (res.data.error) {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              setIsForceChangePasswordDialogOpen(false);
              getAccount(sessionToken);
              messageStore.getState().setMessage(sessionToken, TR.ww_password_changed);
            }
          })
          .catch(function () { });
      } else {
        setError(sessionToken, 0, TR.ww_passwords_must_match);
      }
    } else {
      setError(sessionToken, 0, TR.ww_password_too_short);
    }
  };

  const renderForceChangePassword = () => {
    return <ForceChangePassword
      open={isForceChangePasswordDialogOpen}
      onClose={handleCloseForceChangePasswordDialog}
      onChangePassword={handleChangePassword}
    />;
  };

  const handleAcceptTerms = (areTermsAccepted) => {
    if (areTermsAccepted) {
      let newAccount = { ...account };
      newAccount.force_accept_terms = 0;
      setAccount(sessionToken, newAccount);
      setIsForceAcceptTermsDialogOpen(false);
    }
  };

  const renderForceAcceptTerms = () => {
    return <ForceAcceptTerms
      open={isForceAcceptTermsDialogOpen}
      onClose={handleCloseForceAcceptTermsDialog}
      onAcceptTerms={handleAcceptTerms}
    />;
  };

  const renderIfLoggedIn = () => {
    console.log("muvikaApp");
    if (isSessionOpen && isLoggedIn) {
      if (account) {
        if (account.force_pw_change) {
          return <Navigate to="/forcechangepassword" />;
        } else if (account.force_accept_terms) {
          return <Navigate to="/forceacceptterms" />;
        }
      }
      return <ThemeProvider theme={darkTheme}>
        <Error />
        <Message />
        <CssBaseline />
        <CurrentTime />
        <IosExternalLinkDialog
          open={isIosExternalLinkDialogOpen}
          onClose={handleCloseIosExternalLinkDialog}
          message={TR.cm_external_link_account_ios}
          url={"https://muvika.com"}
        />
        <AndroidSubDialog
          open={isAndroidSubDialogOpen}
          onClose={handleCloseAndroidSubDialog}
          onOk={handleAndroidSubDialogOk}
        />
        {renderSubscribeDialog()}
        {renderPopUpDialog()}
        {renderUpdateDialog()}
        {renderMessageDialog()}
        <Messenger />
        <HiddenEvents />
        {renderView()}
      </ThemeProvider>;
    } else {
      if (!isWaitingLoggedIn) {
        resetStores();
      }
      return <Navigate to="/login" />;
    }
  };

  const showSubscribeDialogIfNecessary = () => {
    if (!isUnsubscriptionDialogShown) {
      if (account) {
        if (!settingsAccountPin && account.subscription.valid == 0 && account.subscription.order_info.actions.includes("subscribe") && !account.subscription.order_info.popup_msg) {
          setIsSubscribeDialogOpen(true);
        }
      }
    }
  };

  const showPopUpDialogIfNecessary = () => {
    if (!navigationStore.getState().isPopUpDialogShown) {
      if (accountStore.getState().account) {
        if (accountStore.getState().account.subscription.order_info.popup_msg) {
          setIsPopUpDialogOpen(true);
        }
      }
    }
  };

  const adjustHeight = () => {
    const target = document.getElementById("muvika-performance-list-container");
    const reference = document.getElementById(
      "muvika-playqueue-bottom-bar"
    );
    if (!target || !reference) return;
    const targetTop = target.getBoundingClientRect().top;
    const referenceBottom = reference.getBoundingClientRect().top;
    const newHeight = referenceBottom - targetTop;
    if (newHeight > 0) {
      target.style.minHeight = `${newHeight}px`;
    }
  };

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      App.addListener('appStateChange', ({ isActive }) => {
        if (isActive) {
          if (accountStore.getState().account) {
            if (accountStore.getState().account.subscription.order_info.popup_msg) {
              setIsPopUpDialogOpen(true);
            }
          }
        }
      });
    }
    adjustHeight();
    window.addEventListener("resize", adjustHeight);
    window.addEventListener("refitcontainer", adjustHeight);
    window.addEventListener("refitbuttons", adjustHeight);
  }, []);

  useEffect(() => {
    showSubscribeDialogIfNecessary();
    showPopUpDialogIfNecessary();
  }, [currentError]);

  useEffect(() => {
    showSubscribeDialogIfNecessary();
    showPopUpDialogIfNecessary();
  }, [isUnsubscriptionDialogShown]);

  useEffect(() => {
    showSubscribeDialogIfNecessary();
    showPopUpDialogIfNecessary();
  }, [account]);

  return (
    <div>
      {renderIfLoggedIn()}
    </div>
  );
}

export default MuvikaUI;
